import React from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

type AuthProps = {
  signOut: () => void;
  user: any;
};

interface LoginProps {
  children: (props: AuthProps) => React.ReactElement;
}

// Configure Amplify
console.log('Stack name:', process.env.REACT_APP_STACK_NAME);
console.log('Domain:', `${process.env.REACT_APP_STACK_NAME}-auth.auth.us-east-1.amazoncognito.com`);
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
      loginWith: {
        oauth: {
          domain: `${process.env.REACT_APP_STACK_NAME}-auth.auth.us-east-1.amazoncognito.com`,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: process.env.NODE_ENV === 'development' 
            ? ['http://localhost:3000']
            : ['https://dt4z2hnfzybig.cloudfront.net'],
          redirectSignOut: process.env.NODE_ENV === 'development'
            ? ['http://localhost:3000']
            : ['https://dt4z2hnfzybig.cloudfront.net'],
          responseType: 'code'
        }
      }
    }
  }
});

export const Login: React.FC<LoginProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <Authenticator
        initialState="signIn"
        socialProviders={['google']}
        variation="modal"
        components={{
          Header() {
            return (
              <div className="text-center p-4">
                <h1 className="text-2xl font-bold text-talaera-blue">Talaera AI Playground</h1>
              </div>
            );
          },
        }}
      >
        {({ user, signOut }) => children({
          signOut: () => signOut?.(),
          user
        })}
      </Authenticator>
    </ThemeProvider>
  );
}; 